import React, { useState } from 'react';
import { Form, Button, InputGroup } from 'react-bootstrap';
import { toast } from 'react-toastify';

const RequestBodyForm = ({ 
    requestBodyType, 
    setRequestBodyType, 
    requestBodyAttributes, 
    setRequestBodyAttributes, 
    formData, 
    setFormData,
    requestParameters 
}) => {
    const [newBodyAttributeName, setNewBodyAttributeName] = useState('');
    const [newBodyAttributeValue, setNewBodyAttributeValue] = useState('');
    const [newBodyAttributeValueType, setNewBodyAttributeValueType] = useState('custom');

    const handleAddBodyAttribute = () => {
        if (!newBodyAttributeName.trim()) {
            toast.error('Attribute name is required');
            return;
        }
        if (requestBodyAttributes.some(attr => attr.name === newBodyAttributeName)) {
            toast.error('Attribute name already exists');
            return;
        }
        const newAttributes = [...requestBodyAttributes, {
            name: newBodyAttributeName.trim(),
            value: newBodyAttributeValue,
            valueType: newBodyAttributeValueType
        }];
        setRequestBodyAttributes(newAttributes);
        setFormData(prev => ({ ...prev, requestBody: { type: requestBodyType, attributes: newAttributes } }));
        setNewBodyAttributeName('');
        setNewBodyAttributeValue('');
        setNewBodyAttributeValueType('custom');
    };

    const handleDeleteBodyAttribute = (index) => {
        const newAttributes = requestBodyAttributes.filter((_, i) => i !== index);
        setRequestBodyAttributes(newAttributes);
        setFormData(prev => ({ ...prev, requestBody: { type: requestBodyType, attributes: newAttributes } }));
    };

    const handleRequestBodyTypeChange = (type) => {
        setRequestBodyType(type);
        setFormData(prev => ({ ...prev, requestBody: { type, attributes: requestBodyAttributes } }));
    };

    return (
        <>
            <Form.Group className="mt-3">
                <Form.Label>Request Body Type</Form.Label>
                <Form.Control
                    as="select"
                    value={requestBodyType}
                    onChange={(e) => handleRequestBodyTypeChange(e.target.value)}
                >
                    <option value="none">None</option>
                    <option value="raw">Raw</option>
                    <option value="formdata">Form Data</option>
                    <option value="binary">Binary</option>
                    <option value="x-www-form-urlencoded">x-www-form-urlencoded</option>
                </Form.Control>
            </Form.Group>

            {requestBodyType !== 'none' && (
                <Form.Group className="mt-3">
                    <Form.Label>Request Body Attributes</Form.Label>
                    <div className="mb-2">
                        <InputGroup>
                            <Form.Control
                                type="text"
                                placeholder="Attribute Name"
                                value={newBodyAttributeName}
                                onChange={(e) => setNewBodyAttributeName(e.target.value)}
                            />
                            <Form.Control
                                as="select"
                                value={newBodyAttributeValueType}
                                onChange={(e) => setNewBodyAttributeValueType(e.target.value)}
                            >
                                <option value="custom">Custom Value</option>
                                <option value="parameter">Request Parameter</option>
                            </Form.Control>
                            {newBodyAttributeValueType === 'custom' ? (
                                <Form.Control
                                    type="text"
                                    placeholder="Value"
                                    value={newBodyAttributeValue}
                                    onChange={(e) => setNewBodyAttributeValue(e.target.value)}
                                />
                            ) : (
                                <Form.Control
                                    as="select"
                                    value={newBodyAttributeValue}
                                    onChange={(e) => setNewBodyAttributeValue(e.target.value)}
                                >
                                    <option value="">Select Parameter</option>
                                    {requestParameters.map((param) => (
                                        <option key={param.value} value={param.value}>
                                            {param.label}
                                        </option>
                                    ))}
                                </Form.Control>
                            )}
                            <Button variant="primary" onClick={handleAddBodyAttribute}>
                                Add Attribute
                            </Button>
                        </InputGroup>
                    </div>
                    {requestBodyAttributes.length > 0 ? (
                        <div className="border rounded p-2">
                            {requestBodyAttributes.map((attr, index) => (
                                <div key={index} className="d-flex align-items-center mb-2">
                                    <div className="flex-grow-1">
                                        <strong>{attr.name}:</strong>{' '}
                                        {attr.valueType === 'parameter' ? (
                                            <span className="text-primary">{attr.value}</span>
                                        ) : (
                                            attr.value
                                        )}
                                    </div>
                                    <Button
                                        variant="outline-danger"
                                        size="sm"
                                        onClick={() => handleDeleteBodyAttribute(index)}
                                    >
                                        <i className="fa fa-trash"></i>
                                    </Button>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div className="text-muted">No attributes added</div>
                    )}
                </Form.Group>
            )}
        </>
    );
};

export default RequestBodyForm; 